var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvironmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.224121,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#3F46AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3343_8938",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.22412,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3343_8938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1 19.2241H16.9C17.05 19.2241 17.1792 19.1616 17.2875 19.0366C17.3958 18.9116 17.4333 18.7741 17.4 18.6241L16.925 15.9991C17.2583 15.8325 17.5208 15.5908 17.7125 15.2741C17.9042 14.9575 18 14.6075 18 14.2241C18 13.6741 17.8042 13.2033 17.4125 12.8116C17.0208 12.42 16.55 12.2241 16 12.2241C15.45 12.2241 14.9792 12.42 14.5875 12.8116C14.1958 13.2033 14 13.6741 14 14.2241C14 14.6075 14.0958 14.9575 14.2875 15.2741C14.4792 15.5908 14.7417 15.8325 15.075 15.9991L14.6 18.6241C14.5667 18.7741 14.6042 18.9116 14.7125 19.0366C14.8208 19.1616 14.95 19.2241 15.1 19.2241ZM16 26.1241C15.8833 26.1241 15.775 26.1158 15.675 26.0991C15.575 26.0825 15.475 26.0575 15.375 26.0241C13.125 25.2741 11.3333 23.8866 10 21.8616C8.66667 19.8366 8 17.6575 8 15.3241V10.5991C8 10.1825 8.12083 9.80748 8.3625 9.47415C8.60417 9.14081 8.91667 8.89915 9.3 8.74915L15.3 6.49915C15.5333 6.41581 15.7667 6.37415 16 6.37415C16.2333 6.37415 16.4667 6.41581 16.7 6.49915L22.7 8.74915C23.0833 8.89915 23.3958 9.14081 23.6375 9.47415C23.8792 9.80748 24 10.1825 24 10.5991V15.3241C24 17.6575 23.3333 19.8366 22 21.8616C20.6667 23.8866 18.875 25.2741 16.625 26.0241C16.525 26.0575 16.425 26.0825 16.325 26.0991C16.225 26.1158 16.1167 26.1241 16 26.1241ZM16 24.1241C17.7333 23.5741 19.1667 22.4741 20.3 20.8241C21.4333 19.1741 22 17.3408 22 15.3241V10.5991L16 8.34915L10 10.5991V15.3241C10 17.3408 10.5667 19.1741 11.7 20.8241C12.8333 22.4741 14.2667 23.5741 16 24.1241Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentIcon);
export default __webpack_public_path__ + "static/media/Environment_icon.674d094bd8ab3785c05c072dba6e7ca8.svg";
export { ForwardRef as ReactComponent };